/*
 This file is part of GNU Taler
 Copyright (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.
 */

export type RandomBytesProvider = (length: number) => Uint8Array;

let randomBytesProvider: RandomBytesProvider = () => {
  throw new Error("no PRNG");
};

export function setRandomBytesProvider(provider: RandomBytesProvider): void {
  randomBytesProvider = provider;
}

export function randomBytes(length: number): Uint8Array {
  const result = randomBytesProvider(length);
  if (!(result instanceof Uint8Array) || result.byteLength !== length) {
    throw new Error(
      `PRNG returned ${result.byteLength} bytes, expected ${length}`,
    );
  }
  return result;
}
